/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { exportNetworkDefinition } from '../fn/networks/export-network-definition';
import { ExportNetworkDefinition$Params } from '../fn/networks/export-network-definition';
import { importNetworkDefinition } from '../fn/networks/import-network-definition';
import { ImportNetworkDefinition$Params } from '../fn/networks/import-network-definition';
import { NetworkList } from '../models/network-list';
import { searchNetworks } from '../fn/networks/search-networks';
import { searchNetworks$Any } from '../fn/networks/search-networks-any';
import { SearchNetworks$Any$Params } from '../fn/networks/search-networks-any';
import { SearchNetworks$Params } from '../fn/networks/search-networks';


/**
 * All about the networks
 */
@Injectable({ providedIn: 'root' })
export class NetworksService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchNetworks()` */
  static readonly SearchNetworksPath = '/networks/search';

  /**
   * Search networks, with pagination.
   *
   * Search networks, with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchNetworks()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchNetworks$Response(params?: SearchNetworks$Params, context?: HttpContext): Observable<StrictHttpResponse<NetworkList>> {
    return searchNetworks(this.http, this.rootUrl, params, context);
  }

  /**
   * Search networks, with pagination.
   *
   * Search networks, with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchNetworks$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchNetworks(params?: SearchNetworks$Params, context?: HttpContext): Observable<NetworkList> {
    return this.searchNetworks$Response(params, context).pipe(
      map((r: StrictHttpResponse<NetworkList>): NetworkList => r.body)
    );
  }

  /**
   * Search networks, with pagination.
   *
   * Search networks, with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchNetworks$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchNetworks$Any$Response(params?: SearchNetworks$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<NetworkList>> {
    return searchNetworks$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search networks, with pagination.
   *
   * Search networks, with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchNetworks$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchNetworks$Any(params?: SearchNetworks$Any$Params, context?: HttpContext): Observable<NetworkList> {
    return this.searchNetworks$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<NetworkList>): NetworkList => r.body)
    );
  }

  /** Path part for operation `importNetworkDefinition()` */
  static readonly ImportNetworkDefinitionPath = '/networks/import';

  /**
   * Import the the Networks Definitionn.
   *
   * Allows to import the Networks Definition, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importNetworkDefinition()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importNetworkDefinition$Response(params?: ImportNetworkDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importNetworkDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the the Networks Definitionn.
   *
   * Allows to import the Networks Definition, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importNetworkDefinition$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importNetworkDefinition(params?: ImportNetworkDefinition$Params, context?: HttpContext): Observable<void> {
    return this.importNetworkDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportNetworkDefinition()` */
  static readonly ExportNetworkDefinitionPath = '/networks/export';

  /**
   * Export the Networks Definition.
   *
   * Allows to export the the Networks Definition.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportNetworkDefinition()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportNetworkDefinition$Response(params?: ExportNetworkDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportNetworkDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the Networks Definition.
   *
   * Allows to export the the Networks Definition.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportNetworkDefinition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportNetworkDefinition(params?: ExportNetworkDefinition$Params, context?: HttpContext): Observable<Blob> {
    return this.exportNetworkDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
